import { inject } from '@angular/core';
import { MaybeAsync, Router } from '@angular/router';
import { defer, from, isObservable, Observable, of, switchMap } from 'rxjs';

import { ModalType } from '@connect-services/client/components/abstract-modal/abstract-modal.component';
import { RouterService } from '@connect-services/client/services/router.service';

export const bypassDeactivateModal = 'bypassDeactivateModal';

export interface DeactivateDialogConfig {
    confirmLabel?: string;
    description?: string;
    title?: string;
    type: ModalType;
    width?: string;
}

export interface ComponentCanDeactivate {
    canDeactivate: () => MaybeAsync<boolean>;
    getDeactivateDialogConfig?: () => DeactivateDialogConfig;
}

export function canDismountGuard(component: ComponentCanDeactivate): Observable<boolean> {
    const routerService = inject(RouterService);
    const router = inject(Router);

    return defer(() => {
        const result: MaybeAsync<boolean> = component.canDeactivate();

        if (isObservable(result)) {
            return result;
        }

        return result instanceof Promise ? from(result) : of(result);
    }).pipe(
        switchMap((canLeave: boolean) => {
            if (canLeave || router.currentNavigation()?.extras?.info === bypassDeactivateModal) {
                return of(true);
            }

            const config: DeactivateDialogConfig | undefined = component.getDeactivateDialogConfig?.();

            return routerService.confirmBeforeLeavingPage(config);
        }),
    );
}
